import React from "react";
import { cn } from "../helper/classNames";

interface CustomCardProps extends React.PropsWithChildren<{}> {
	className?: string;
	onClick?: () => void;
	size?: "default" | "small";
	imageSrc?: string;
	subcategories?: string[]; // Added subcategories prop
	subCatOnClick?: (val: any) => void;
	style?: {}
}

const CustomCard = (props: CustomCardProps) => {
	const { children, onClick, style = {} } = props;

	return (
		<div
			onClick={onClick}
			className={cn("custom-card", props.className)} // Assuming cn() is for conditional class names
			style={style}
		>
			{/* Card body content */}
			<div style={{ padding: '10px 20px' }}>
				{children}
			</div>
		</div>
	);
};

export default CustomCard;
